import {GetLifeplaceLinkParams} from 'domain/usecases/private/lifeplace/get-lifeplace-link';
import {makeGetLifeplaceLink} from 'main/factories/usecases/private/lifeplace/get-lifeplace-link-factory';

export async function getLifeplaceLink(params: GetLifeplaceLinkParams) {
	const response = await makeGetLifeplaceLink().get(params);

	const link = response?.url;

	return link;
}
